import '@onereach/styles/main-v3.css';

import { createApp } from 'vue';

import i18n from '@/i18n';
import router from '@/router';
import SentryApi from '@/sentry';

import AppRoot from './AppRoot.vue';
import createPinia from './stores';

const app = createApp(AppRoot);

app.use(i18n);
app.use(createPinia());
app.use(router);

// handle vue warnings to exclude some of them
app.config.warnHandler = (msg, instance, trace) =>
  ![
    'Extraneous non-props attributes (data-test)', // we use this attribute for testing
  ].some((warning) => msg.includes(warning)) &&
  console.warn('[Vue warn]: '.concat(msg).concat(trace));

SentryApi.init(app, router);

export default app;
